<template>
  <v-container fluid class="pa-2">
    <v-row>
      <v-col>
        <h2 class="mb-3">
          <div class="pull-left">{{ title }}</div>
          <div class="clearfix"></div>
        </h2>

        <div v-if="properties" class="mb-1">
          <div v-for="(prop, index) in properties" :key="index">{{ prop }}</div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MODULE_PREFIX_HOME } from "@/store";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { mapGetters } from "vuex";

export default {
  name: "MapControlsDetails",
  computed: {
    ...mapGetters({
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
  },
  data: () => ({
    title: null,
    properties: [],
  }),
  mounted() {
    if (this.detailsSidebar.selected === DETAIL_SIDEBAR_TYPES.mapControls) {
      this.title = this.detailsSidebar.title;
      if (this.detailsSidebar?.features?.[0]) {
        const propsObj = this.detailsSidebar.features[0];
        const properties = [];
        Object.keys(propsObj).forEach((key) => {
          properties.push(propsObj[key]);
        });
        this.properties = properties;
      }
    }
  },
};
</script>

<style scoped></style>
